












































import Vue from 'vue'
import { Route, RawLocation } from 'vue-router'
import Input from '@/components/shared/atoms/Input'
import FormBlock from '@/components/shared/molecules/Form/FormBlock'
import FormWrapper from '@/components/shared/organisms/FormWrapper'
import Checkbox from '@/components/shared/atoms/Checkbox'
import Modal from '@/components/shared/atoms/Modal'
import Button from '@/components/shared/atoms/Button/Button'
import LinkButton from '@/components/shared/atoms/Button/LinkButton'
import YLogin from '@/components/Auth/YahooLoginButton/Login'

import LoginValidator, { Fields, FieldErrors } from '@/utils/validators/form/Auth/Login'
import PWResetRequestContainer from '@/containers/Auth/PWResetRequest'
import { extractTargetFields } from '@/utils/helper'
import LoginUseCase from '@/usecases/auth/LoginUseCase'

interface IData {
  fields: Fields
  enableCheckFlg: { [key in keyof Fields]: boolean }
  rememberMe: boolean
  showRememberMe: boolean
  showForgotPassword: boolean
  submitting: boolean
}

export default Vue.extend({
  components: {
    FormBlock,
    FormWrapper,
    Input,
    Checkbox,
    Modal,
    Button,
    LinkButton,
    PWResetRequestContainer,
    YLogin
  },
  props: {
    redirectTo: {
      type: String,
      default: null
    },
    presetEmail: {
      type: String,
      default: null
    },
    token: {
      type: String,
      default: null
    },
    forwardedParams: {
      type: Object as () => Route['params'],
      required: true
    },
    forwardedQueries: {
      type: Object as () => Route['query'],
      required: true
    }
  },
  data(): IData {
    return {
      rememberMe: false,
      showRememberMe: false,
      showForgotPassword: false,
      fields: {
        email: '',
        password: ''
      },
      enableCheckFlg: {
        email: false,
        password: false
      },
      submitting: false
    }
  },
  computed: {
    formErrors(): FieldErrors {
      const targetFields = extractTargetFields(this.fields, this.enableCheckFlg)

      return LoginValidator.validate(targetFields)
    },
    isFullfilled(): boolean {
      // TODO: 要改善
      const { email, password } = this.fields
      if (email === '') return false
      if (password === '') return false

      return true
    },
    canLogin(): boolean {
      const hasErrors = Object.values(this.formErrors).some(field => field.length !== 0)
      return this.isFullfilled && !hasErrors && !this.submitting
    },
    signupPath(): RawLocation {
      return { name: 'signup', query: { email: this.presetEmail, redirectTo: this.redirectTo, token: this.token, ...this.forwardedParams, ...this.forwardedQueries } }
    }
  },
  watch: {
    rememberMe: {
      handler(val: boolean) {
        if (val) {
          // TODO 2回目以降はモーダルを開かない
          this.showRememberMe = true
        }
      }
    }
  },
  methods: {
    enableCheck(str: keyof Fields) {
      this.enableCheckFlg[str] = true
    },
    transformHankaku() {
      // TODO: Inputのblurでこのメソッドを呼び、全角文字を半角文字に変換する。watchで常時強制的に変換するよりはユーザー体験的に良さそう - 20190308 Shin Ando
    },
    async login() {
      // Enable all validation flg
      Object.keys(this.fields).forEach(field => this.enableCheck(field as keyof Fields))

      if (!this.canLogin) return

      const usecase = this.$kernel.resolve(LoginUseCase)
      const params = {
        ...this.fields,
        rememberMe: this.rememberMe
      }
      try {
        this.submitting = true
        await usecase.execute(params)
        this.$router.push(this.redirectTo ? { name: this.redirectTo, params: this.forwardedParams, query: this.forwardedQueries } : '/family')
      } catch (e) {
        if (e.inquiryNum) {
          /*
           ** ANCHOR Y!ログイン問題の該当者の場合、コーポレートへリダイレクトさせる
           */
          this.submitting = false

          location.href = `https://www.photocreate.co.jp/contact/can_not_login/?inquiryNum=${e.inquiryNum}`
          return
        }
        this.submitting = false
        this.$toastRepository.addQueue({
          type: 'error',
          text: '入力内容にエラーがあります。ご確認ください'
        })
      }
    }
  }
})
